import React, { PropsWithChildren, createContext } from 'react';
import { useDispatch } from 'react-redux';
import { GetDashboardAndRouteToNextStep } from '../../dashboard/ducks/actions';
import { useHistory } from 'react-router';

const defaultProps = {
  onSubmit: () => Promise.resolve()
};

const SubmitContext = createContext(defaultProps);

const WebSubmitProvider: React.FC<PropsWithChildren<{}>> = ({ children }) => {
  const dispatch = useDispatch();
  const onSubmit = () => dispatch(GetDashboardAndRouteToNextStep());

  // The Typescript Error below is because of Redux Promise.
  // As we find other alternatives to this we can remove it.
  return (
    <SubmitContext.Provider value={{ onSubmit }}>
      {children}
    </SubmitContext.Provider>
  );
};

const NativeSubmitProvider: React.FC<PropsWithChildren<{}>> = ({
  children
}) => {
  const history = useHistory();
  const onSubmit = () => {
    history.push('/step-complete');
    return Promise.resolve();
  };

  return (
    <SubmitContext.Provider value={{ onSubmit }}>
      {children}
    </SubmitContext.Provider>
  );
};

export default SubmitContext;
export { WebSubmitProvider, NativeSubmitProvider };
